import { getField, updateField } from 'vuex-map-fields';
import CoursesService from '@/services/CoursesService';
import router from '../../router';

const getDefaultState = function () {
    return {
        id: null,
        unitDisplayName: null,
        question: null,
        answer: null,
        detailedAnswer: null,
        level: null,
        status: null
    };
};

/* eslint no-shadow: ["error", { "allow": ["state"] }] */
const state = getDefaultState();

const getters = {
    getField,
    form: (state) => ({
        id: state.id,
        unitDisplayName: state.unitDisplayName,
        question: state.question,
        answer: state.answer,
        detailedAnswer: state.detailedAnswer,
        level: state.level,
        status: state.status
    }),
};

const mutations = {
    setExpoChapterQuestion(state, value) {
        if (value) {
            // value.Transfers.forEach((status) => {
            //     status.Events.sort((a, b) => new Date(a.Date) - new Date(b.Date));
            // });
            Object.assign(state, value);
        } else {
            Object.assign(state, getDefaultState());
        }
    },

    storeReportDetails(state, data) {
        Object.assign(state, data);
    },
    updateField,
};

const actions = {
    async loadExpoChapterQuestion({ commit }, data) {
        console.log(router);
        const res = await CoursesService.getExpoChapterQuestion(router.currentRoute.params.id, {
            EntityId: data.id
        });
        commit('setExpoChapterQuestion', res.data.items[0]);
        return res.data;
    },
    async loadExpoChapterQuestionAdmin({ commit }, data) {
        const res = await CoursesService.getReportAdmin(data.id);
        commit('setExpoChapterQuestion', res.data);
        return res.data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
